import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × BANG & OLUFSEN: Acoustic geometry
// Circular resonance, harmonic grids, wave tessellation
export function VasarelyBoMode({ brand }: ModeRendererProps) {
  const boSilver = "#C0C0C0";

  return (
    <g>
      {/* Acoustic background */}
      <defs>
        <radialGradient id="bo-sound">
          <stop offset="0%" stopColor="#1A1A1A" />
          <stop offset="100%" stopColor="#0A0A0A" />
        </radialGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#bo-sound)" />

      <g transform="translate(397 540)">
        {/* Circular resonance (sound waves) */}
        {Array.from({ length: 24 }).map((_, i) => {
          const r = 30 + i * 12;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={boSilver}
              strokeWidth="2"
              opacity={0.5 - i * 0.018}
            />
          );
        })}

        {/* Harmonic grid (speaker lattice) */}
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 20 }).map((_, j) => {
            const x = (i - 7.5) * 42;
            const y = (j - 9.5) * 40;
            const harmonic = Math.sin(i * 0.4) * Math.cos(j * 0.3) * 10;
            
            return (
              <circle
                key={`${i}-${j}`}
                cx={x}
                cy={y + harmonic}
                r="6"
                fill={boSilver}
                opacity="0.2"
              />
            );
          })
        )}

        {/* Wave tessellation */}
        {Array.from({ length: 12 }).map((_, i) => {
          const y = -240 + i * 40;
          const points = Array.from({ length: 40 }).map((_, j) => {
            const x = -280 + j * 14;
            const wave = Math.sin(j * 0.3 + i * 0.5) * 25;
            return `${x},${y + wave}`;
          }).join(" ");
          
          return (
            <polyline
              key={i}
              points={points}
              fill="none"
              stroke={boSilver}
              strokeWidth="2"
              opacity="0.4"
            />
          );
        })}

        {/* Sound clarity nodes */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 190;
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="40"
                fill={boSilver}
                opacity="0.1"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="14"
                fill={boSilver}
                opacity="0.6"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="20"
                fill="none"
                stroke={boSilver}
                strokeWidth="2"
                opacity="0.5"
              />
            </g>
          );
        })}

        {/* Acoustic symmetry lines */}
        {Array.from({ length: 32 }).map((_, i) => {
          const angle = (i * Math.PI) / 16;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 250}
              y2={Math.sin(angle) * 250}
              stroke={boSilver}
              strokeWidth="1"
              opacity="0.15"
            />
          );
        })}

        {/* Central speaker cone */}
        <circle cx="0" cy="0" r="80" fill={brand.black} opacity="0.8" />
        <circle cx="0" cy="0" r="80" fill="none" stroke={boSilver} strokeWidth="4" opacity="0.7" />
        <circle cx="0" cy="0" r="60" fill="none" stroke={boSilver} strokeWidth="2" opacity="0.5" />
        <circle cx="0" cy="0" r="40" fill="none" stroke={boSilver} strokeWidth="1.5" opacity="0.4" />
      </g>

      {/* Bang & Olufsen text */}
      <text x="397" y="1020" textAnchor="middle" fontFamily="sans-serif" fontSize="11" fill={boSilver} opacity="0.7" fontStyle="italic">
        géométrie acoustique
      </text>
    </g>
  );
}
